import { Wallet } from 'lucide-react';

/**
 * Wallet section component
 * @param {object} props
 * @param {number} props.walletDiscount - Applied wallet discount amount
 * @param {function} props.onWalletClick - Callback when wallet button is clicked
 */
const WalletSection = ({ walletDiscount, onWalletClick }) => {
	return (
		<>
			<div className="mb-4">
				<button
					type="button"
					onClick={onWalletClick}
					className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-lg transition-colors duration-200 text-gray-700"
					title="Utiliser mon portefeuille parrainage"
				>
					<span className="text-sm font-medium">Utiliser mon portefeuille parrainage</span>
					<Wallet className="w-5 h-5" />
				</button>
			</div>

			{walletDiscount > 0 && (
				<div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg">
					<p className="text-sm text-gray-700">
						Réduction appliquée : <span className="font-bold text-green-600">-{walletDiscount.toFixed(2)} €</span>
					</p>
				</div>
			)}
		</>
	);
};

export default WalletSection;

